module.exports = __webpack_public_path__ + "img/logos.5eba0d74.png";